export enum ReceivedType {
    NotReceived = 0,
    Standard = 1,
    OneClick = 2,
    Auto = 3
}